<template>
  <ResponsivePopoverView v-model:active="active" placement="bottom">
    <template v-slot:target>
      <ButtonView type="shaded" color="foreground" size="small" :active="active || editor.isActive('heading')" @click="active = true">
        <i v-if="editor.isActive({ textAlign: 'center' })" class="fas fa-align-center fa-fw" style="font-size: 1.2em"></i>
        <i v-else-if="editor.isActive({ textAlign: 'right' })" class="fas fa-align-right fa-fw" style="font-size: 1.2em"></i>
        <i v-else-if="editor.isActive({ textAlign: 'justify' })" class="fas fa-align-justify fa-fw" style="font-size: 1.2em"></i>
        <i v-else class="fas fa-align-left fa-fw" style="font-size: 1.2em"></i>
      </ButtonView>
    </template>
    <template v-slot:body>
      <ButtonView type="shaded" color="foreground" @click="editor.chain().focus().setTextAlign('left').run()" :active="editor.isActive({ textAlign: 'left' })">
        <i class="fas fa-align-left fa-fw"></i>
      </ButtonView>
      <ButtonView type="shaded" color="foreground" @click="editor.chain().focus().setTextAlign('center').run()" :active="editor.isActive({ textAlign: 'center' })">
        <i class="fas fa-align-center fa-fw"></i>
      </ButtonView>
      <ButtonView type="shaded" color="foreground" @click="editor.chain().focus().setTextAlign('right').run()" :active="editor.isActive({ textAlign: 'right' })">
        <i class="fas fa-align-right fa-fw"></i>
      </ButtonView>
      <ButtonView type="shaded" color="foreground" @click="editor.chain().focus().setTextAlign('justify').run()" :active="editor.isActive({ textAlign: 'justify' })">
        <i class="fas fa-align-justify fa-fw"></i>
      </ButtonView>
    </template>
  </ResponsivePopoverView>
</template>

<script setup>
import ResponsivePopoverView from "../../../general/ResponsivePopoverView.vue";
import ButtonView from "../../../general/ButtonView.vue";
import {ref} from "vue";

defineProps({
  editor: Object
});

const active = ref(false);

</script>